<template>
	<n-link
		:to="{ name: 'article', params: { category: article.category, slug: article.slug } }"
		:title="article.title"
		class="article-card"
	>
		<v-card
			:elevation="$attrs.elevation || 0"
			tile
		>
			<v-row no-gutters>
				<v-col
					v-resize="onResize"
					cols="12"
					class="pa-3"
				>
					<z-img
						:storage="article.featured"
						:alt="article.title"
						max-width="100%"
						:max-height="maxHeight"
					/>
				</v-col>
				<v-col
					cols="12"
					class="article-info px-4 pt-0"
				>
					{{ article.title }}
				</v-col>
				<v-col
					cols="12"
					class="pa-4 pt-0"
				>
					<div class="mt-auto d-flex align-center">
						<v-icon
							class="mr-1"
							color="rgb(237,28,36)"
							small
						>
							mdi-clock
						</v-icon>
						{{ date(article.created_at || null) }}
					</div>
				</v-col>
			</v-row>
		</v-card>
	</n-link>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
	props: {
		article: {
			type: Object,
			default: () => ({})
		},
		extraHeight: {
			type: Number,
			default: 0
		}
	},
	data:() => ({
		maxHeight: '100%',
		dateFormat: new Intl.DateTimeFormat('th-TH', { dateStyle: 'long' })
	}),
	computed: {
		...mapGetters({
			getLocation: 'getLocation',
			getProperty: 'property/getProperty',
			isFavorite: 'property/isFavorite'
		})
	},
	watch: {
		// xs () {
		// 	this.onResize()
		// }
	},
	created() {

	},
	methods: {
		...mapActions({
			addOrRemoveFavorite: 'property/addOrRemoveFavorite'
		}),

		onResize () {
			if (process.client) {
				this.maxHeight = (window.innerWidth > 959 ? 140 : (window.innerWidth > 599 ? 234 : 263)) + this.extraHeight
			}
		},

		date (ts) {
			if (ts) {
				return this.dateFormat.format(ts.seconds * 1000)
			}

			return ''
		}
	},
}
</script>

<style lang="scss" scoped>
.article-card {
	font-size: 0.9rem;
	font-weight: bold;
	text-decoration: none;
	color: #000;

	.article-info {
		min-height: 70px;
    max-height: 70px;
    overflow: hidden;
	}
}
</style>
